<template>
  <el-container class="chat-page" :class="{ 'is-mobile': isMobile, 'mobile-show-chat': isMobile && showMobileChat }">
    <resizable-aside v-show="!isMobile || !showMobileChat" :default-width="280" :min-width="220" :max-width="520" storage-key="chat-aside-width">
      <div class="header">
        <div class="header-top">
          <el-radio-group v-model="sessionMode" size="mini" @change="onChangeSessionMode">
            <el-radio-button label="active">当前会话</el-radio-button>
            <el-radio-button label="history">历史会话</el-radio-button>
          </el-radio-group>
          <div class="header-actions">
            <el-button size="mini" icon="el-icon-remove-outline" @click="openBlacklistDrawer">黑名单</el-button>
            <el-button size="mini" icon="el-icon-refresh" @click="reloadWorkbenchData"></el-button>
          </div>
        </div>
        <el-input class="search-text" size="small" placeholder="搜索会话" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"></i>
        </el-input>
      </div>
      <div class="chat-loading" v-if="loading" v-loading="true" element-loading-text="消息接收中..."
        element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
      </div>
      <el-scrollbar class="chat-items" v-else>
        <div v-for="chat in displayChats" :key="chat.type + '-' + chat.targetId">
          <chat-item :chat="chat" @click.native="onActiveItem(chat)" @delete="onDelItem(chat)"
            @top="onTop(chat)" @dnd="onDnd(chat)" :active="chat === chatStore.activeChat"></chat-item>
        </div>
      </el-scrollbar>
    </resizable-aside>
    <el-container v-show="!isMobile || showMobileChat" class="chat-main-panel">
      <div v-if="isMobile" class="mobile-chat-nav">
        <el-button icon="el-icon-arrow-left" size="mini" plain @click="backToSessionList">会话列表</el-button>
        <span class="mobile-chat-title">{{ activeChat ? displayChatName(activeChat) : '聊天窗口' }}</span>
      </div>
      <chat-box v-if="chatStore.activeChat" :chat="chatStore.activeChat"
        @session-ended="onSessionEnded" @session-reopened="onSessionReopened"
        @session-blacklisted="onSessionBlacklisted"
        @customer-remark-updated="onCustomerRemarkUpdated"></chat-box>
      <div v-else class="mobile-empty-tip">请选择会话</div>
    </el-container>
    <el-drawer title="黑名单" :visible.sync="showBlacklistDrawer" :size="isMobile ? '92%' : '420px'">
      <div class="blacklist-drawer" v-loading="blacklistLoading">
        <el-empty v-if="!blacklists.length" description="暂无黑名单"></el-empty>
        <el-table v-else :data="blacklists" size="small" stripe>
          <el-table-column label="客户" min-width="160">
            <template slot-scope="{ row }">
              <div class="blacklist-user">
                <el-avatar :size="28" :src="row.visitorHeadImage"></el-avatar>
                <div class="blacklist-user-text">
                  <div>{{ row.visitorNickName || row.visitorUserName || ('访客' + row.visitorUserId) }}</div>
                  <div class="blacklist-user-sub">{{ row.visitorUserName }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="拉黑时间" min-width="140">
            <template slot-scope="{ row }">
              <span>{{ formatDateTime(row.createdTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90">
            <template slot-scope="{ row }">
              <el-button type="text" @click="unblacklist(row)">解除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import ResizableAside from "../components/common/ResizableAside.vue";

export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ResizableAside
  },
  data() {
    return {
      searchText: "",
      sessionMode: "active",
      sessionLoading: false,
      showBlacklistDrawer: false,
      blacklistLoading: false,
      sessionReloadTimer: null,
      lastSessionReloadAt: 0,
      blacklists: [],
      activeSessions: [],
      historySessions: [],
      viewportWidth: typeof window === 'undefined' ? 1200 : window.innerWidth,
      showMobileChat: false
    }
  },
  created() {
    this.reloadWorkbenchData();
    this.$eventBus.$on('refreshAgentSessions', this.scheduleSessionReload);
    // 监听导航模式切换
    if (this.$route.query.mode === 'history') {
      this.sessionMode = 'history';
    }
  },
  beforeDestroy() {
    if (this.sessionReloadTimer) {
      clearTimeout(this.sessionReloadTimer);
      this.sessionReloadTimer = null;
    }
    this.$eventBus.$off('refreshAgentSessions', this.scheduleSessionReload);
    window.removeEventListener('resize', this.handleViewportResize);
  },
  mounted() {
    this.handleViewportResize();
    this.syncMobileChatByRoute();
    window.addEventListener('resize', this.handleViewportResize);
  },
  methods: {
    handleViewportResize() {
      this.viewportWidth = window.innerWidth;
      if (!this.isMobile) {
        this.showMobileChat = false;
        if (this.$route.query && this.$route.query.chatView) {
          const query = { ...this.$route.query };
          delete query.chatView;
          this.$router.replace({ path: this.$route.path, query }).catch(() => {});
        }
      }
    },
    syncMobileChatByRoute() {
      if (!this.isMobile) {
        return;
      }
      const showDetailByRoute = this.$route.query && this.$route.query.chatView === 'detail';
      if (showDetailByRoute && this.chatStore.activeChat) {
        this.showMobileChat = true;
      }
      if (!showDetailByRoute) {
        this.showMobileChat = false;
      }
    },
    syncMobileChatRouteFlag() {
      if (!this.isMobile) {
        return;
      }
      const shouldDetail = !!this.showMobileChat;
      const currentDetail = this.$route.query && this.$route.query.chatView === 'detail';
      if (shouldDetail === currentDetail) {
        return;
      }
      const query = { ...this.$route.query };
      if (shouldDetail) {
        query.chatView = 'detail';
      } else {
        delete query.chatView;
      }
      this.$router.replace({ path: this.$route.path, query }).catch(() => {});
    },
    backToSessionList() {
      this.showMobileChat = false;
      this.syncMobileChatRouteFlag();
    },
    scheduleSessionReload(force = false) {
      const now = Date.now();
      if (force || now - this.lastSessionReloadAt > 1500) {
        this.lastSessionReloadAt = now;
        this.reloadWorkbenchData();
        return;
      }
      if (this.sessionReloadTimer) {
        return;
      }
      this.sessionReloadTimer = setTimeout(() => {
        this.sessionReloadTimer = null;
        this.lastSessionReloadAt = Date.now();
        this.reloadWorkbenchData();
      }, 1600);
    },
    onActiveItem(chat) {
      const index = this.chatStore.findChatIdx(chat);
      if (index >= 0) {
        this.chatStore.setActiveChat(index);
        if (this.isMobile) {
          this.showMobileChat = true;
          this.syncMobileChatRouteFlag();
        }
      }
    },
    onDelItem(chat) {
      const index = this.chatStore.findChatIdx(chat);
      if (index < 0) {
        return;
      }
      if (!(chat.type === 'PRIVATE' && chat.isVisitorSession && chat.sessionId)) {
        this.chatStore.removeChat(index);
        return;
      }
      this.$confirm(
        `确认删除与'${chat.showName}'的聊天吗？将清除该客户与当前代理的全部消息、会话关系和好友关系。`,
        '删除聊天',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$http({
          url: '/agent/session/delete',
          method: 'post',
          data: {
            sessionId: chat.sessionId
          }
        }).then(() => {
          this.chatStore.removeChat(index);
          this.$message.success('聊天已删除');
          this.reloadWorkbenchData();
        });
      }).catch(() => {});
    },
    onTop(chat) {
      const chatIdx = this.chatStore.findChatIdx(chat);
      if (chatIdx >= 0) {
        this.chatStore.toggleTop(chatIdx);
      }
    },
    onDnd(chat) {
      if (chat.type == 'PRIVATE') {
        this.setFriendDnd(chat, chat.targetId, !chat.isDnd)
      } else {
        this.setGroupDnd(chat, chat.targetId, !chat.isDnd)
      }
    },
    setFriendDnd(chat, friendId, isDnd) {
      let formData = {
        friendId: friendId,
        isDnd: isDnd
      }
      this.$http({
        url: '/friend/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.friendStore.setDnd(friendId, isDnd)
        this.chatStore.setDnd(chat, isDnd)
      })
    },
    setGroupDnd(chat, groupId, isDnd) {
      let formData = {
        groupId: groupId,
        isDnd: isDnd
      }
      this.$http({
        url: '/group/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.groupStore.setDnd(groupId, isDnd)
        this.chatStore.setDnd(chat, isDnd)
      })
    },
    onChangeSessionMode() {
      if (this.sessionMode === 'history' && this.chatStore.activeChat && !this.isHistoryChat(this.chatStore.activeChat)) {
        this.chatStore.activeChat = null;
      }
    },
    reloadWorkbenchData() {
      return this.loadAgentSessions();
    },
    loadAgentSessions() {
      this.sessionLoading = true;
      return Promise.all([
        this.$http({ url: '/agent/session/list?status=active', method: 'get' }),
        this.$http({ url: '/agent/session/list?status=history', method: 'get' })
      ]).then(([activeSessions, historySessions]) => {
        this.activeSessions = activeSessions || [];
        this.historySessions = historySessions || [];
        this.syncSessionChats(this.activeSessions);
        this.syncSessionChats(this.historySessions);
      }).finally(() => {
        this.sessionLoading = false;
      });
    },
    syncSessionChats(sessions) {
      sessions.forEach((session) => {
        const chatInfo = {
          type: 'PRIVATE',
          targetId: session.visitorUserId,
          showName: session.visitorRemark || session.visitorNickName || session.visitorUserName || `访客${session.visitorUserId}`,
          headImage: session.visitorHeadImage || '',
          visitorUserName: session.visitorUserName || '',
          visitorNickName: session.visitorNickName || '',
          visitorRemark: session.visitorRemark || '',
          clientIp: session.clientIp || '',
          clientRegion: session.clientRegion || '',
          isDnd: false,
          isVisitorSession: true,
          sessionId: session.sessionId,
          sessionStatus: session.status,
          channelId: session.channelId,
          channelName: session.channelName,
          channelKey: session.channelKey
        };
        this.chatStore.openChat(chatInfo);
        const chat = this.chatStore.findChat(chatInfo);
        if (chat) {
          chat.showName = chatInfo.showName;
          chat.visitorUserName = session.visitorUserName || '';
          chat.visitorNickName = session.visitorNickName || '';
          chat.visitorRemark = session.visitorRemark || '';
          chat.clientIp = session.clientIp || '';
          chat.clientRegion = session.clientRegion || '';
          chat.isVisitorSession = true;
          chat.sessionId = session.sessionId;
          chat.sessionStatus = session.status;
          chat.channelId = session.channelId;
          chat.channelName = session.channelName;
          chat.channelKey = session.channelKey;
          if ((!chat.lastContent || !chat.messages.length) && session.lastMessageContent) {
            chat.lastContent = session.lastMessageContent;
          }
          if (session.lastMessageTime) {
            const messageTime = new Date(session.lastMessageTime).getTime();
            if (!chat.lastSendTime || messageTime > chat.lastSendTime) {
              chat.lastSendTime = messageTime;
            }
          }
          chat.stored = false;
        }
      });
      this.chatStore.refreshChats();
    },
    isHistoryChat(chat) {
      return chat && chat.type === 'PRIVATE' && chat.isVisitorSession && chat.sessionStatus === 2;
    },
    openBlacklistDrawer() {
      this.showBlacklistDrawer = true;
      this.loadBlacklist();
    },
    loadBlacklist() {
      this.blacklistLoading = true;
      return this.$http({
        url: '/agent/blacklist/list',
        method: 'get'
      }).then((blacklists) => {
        this.blacklists = blacklists || [];
      }).finally(() => {
        this.blacklistLoading = false;
      });
    },
    unblacklist(row) {
      this.$confirm(
        `确认解除对'${row.visitorNickName || row.visitorUserName || ('访客' + row.visitorUserId)}'的拉黑吗？`,
        '解除拉黑',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$http({
          url: '/agent/session/unblacklist',
          method: 'post',
          data: {
            visitorUserId: row.visitorUserId
          }
        }).then(() => {
          this.$message.success('已解除拉黑');
          this.loadBlacklist();
        });
      }).catch(() => {});
    },
    formatDateTime(value) {
      if (!value) {
        return '';
      }
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value;
      }
      const pad = (num) => `${num}`.padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} `
        + `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    onSessionEnded(chat) {
      if (chat && this.chatStore.activeChat === chat) {
        this.chatStore.activeChat = null;
      }
      this.reloadWorkbenchData();
    },
    onSessionReopened() {
      this.sessionMode = 'active';
      this.reloadWorkbenchData();
    },
    onCustomerRemarkUpdated() {
      this.reloadWorkbenchData();
    },
    onSessionBlacklisted(chat) {
      const index = this.chatStore.findChatIdx(chat);
      if (index >= 0) {
        this.chatStore.removeChat(index);
      }
      if (this.chatStore.activeChat === chat) {
        this.chatStore.activeChat = null;
      }
      this.reloadWorkbenchData();
      if (this.showBlacklistDrawer) {
        this.loadBlacklist();
      }
    }
  },
  computed: {
    loading() {
      return this.chatStore.loading || this.sessionLoading;
    },
    isMobile() {
      return this.viewportWidth <= 900;
    },
    displayChatName() {
      return (chat) => {
        if (!chat) {
          return '';
        }
        if (chat.type === 'PRIVATE') {
          return chat.visitorRemark || chat.showName || '';
        }
        return chat.showName || '';
      };
    },
    activeChat() {
      return this.chatStore.activeChat;
    },
    displayChats() {
      const text = (this.searchText || '').trim();
      return this.chatStore.chats.filter((chat) => {
        const displayName = this.displayChatName(chat);
        if (chat.delete || !displayName) {
          return false;
        }
        if (
          text &&
          !displayName.includes(text) &&
          !(chat.visitorNickName && chat.visitorNickName.includes(text)) &&
          !(chat.visitorUserName && chat.visitorUserName.includes(text)) &&
          !(chat.channelName && chat.channelName.includes(text))
        ) {
          return false;
        }
        if (this.sessionMode === 'history') {
          return this.isHistoryChat(chat);
        }
        if (chat.type === 'GROUP') {
          return true;
        }
        return !this.isHistoryChat(chat);
      });
    }
  },
  watch: {
    activeChat: {
      handler(chat) {
        if (this.isMobile && !chat) {
          this.showMobileChat = false;
          this.syncMobileChatRouteFlag();
        }
        if (this.isMobile && chat && this.$route.query && this.$route.query.chatView === 'detail') {
          this.showMobileChat = true;
        }
        if (chat && chat.type === 'PRIVATE' && !chat.sessionId) {
          this.scheduleSessionReload(true);
        }
      },
      immediate: true
    },
    showMobileChat() {
      this.syncMobileChatRouteFlag();
    },
    '$route.query.mode': {
      handler(mode) {
        if (mode === 'history') {
          this.sessionMode = 'history';
        } else {
          this.sessionMode = 'active';
        }
      }
    },
    '$route.query.chatView': {
      handler() {
        this.syncMobileChatByRoute();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-page {
  &.is-mobile {
    height: 100%;

    :deep(.resizable-aside) {
      border-right: none;
      box-shadow: none;
    }

    .chat-main-panel {
      border-left: none;
    }
  }

  .header {
    min-height: 84px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 8px;

    .header-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;
    }

    .header-actions {
      display: flex;
      gap: 8px;
      flex-shrink: 0;
    }
  }

  .chat-loading {
    height: 50px;
    background-color: #eee;

    .el-icon-loading {
      font-size: 24px;
      color: var(--im-text-color-light);
    }

    .el-loading-text {
      color: var(--im-text-color-light);
    }
  }

  .chat-items {
    flex: 1;
  }

  .channel-drawer {
    .channel-toolbar {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 12px;
    }

    .link-cell {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .link-text {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--im-text-color-light);
    }
  }

  .blacklist-drawer {
    .blacklist-user {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .blacklist-user-text {
      min-width: 0;
    }

    .blacklist-user-sub {
      color: var(--im-text-color-light);
      font-size: 12px;
    }
  }

  .mobile-chat-nav {
    display: none;
  }

  .mobile-empty-tip {
    display: none;
  }
}

@media (max-width: 900px) {
  .chat-page {
    height: 100dvh;
    min-height: 100dvh;
    overflow: hidden;

    .header {
      min-height: 74px;
      padding: 8px 10px;

      .header-top {
        flex-wrap: wrap;
      }

      .header-actions {
        width: 100%;
        justify-content: flex-end;
      }
    }

    .chat-items {
      height: 100%;
      min-height: 0;
    }

    .chat-main-panel {
      display: flex;
      flex-direction: column;
      background: #fff;
      height: 100dvh;
      min-height: 100dvh;
      overflow: hidden;
    }

    .mobile-chat-nav {
      height: 46px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 10px;
      border-bottom: 1px solid #eef2f6;

      .mobile-chat-title {
        flex: 1;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .mobile-empty-tip {
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--im-text-color-light);
      flex: 1;
      font-size: 14px;
    }
  }
}
</style>
